import React from 'react';
// import { TbSquareRoundedChevronRight } from "react-icons/tb";

const PhraseCarousel = ({ phrases = [], direction = 'ltr' }) => {
  return (
    <div className="relative w-80 overflow-hidden">
      {/* Градиентный оверлей слева */}
      <div className="absolute left-0 top-0 h-full w-1/4 pointer-events-none bg-gradient-to-r from-gray-100 via-gray-100/70 to-transparent" />
      {/* Градиентный оверлей справа */}
      <div className="absolute right-0 top-0 h-full w-1/4 pointer-events-none bg-gradient-to-l from-gray-100 via-gray-100/70 to-transparent" />
      
      {/* Контейнер с анимацией */}
      <div
        className="flex whitespace-nowrap items-center animate-slide"
        style={{ animationDirection: direction === 'rtl' ? 'reverse' : 'normal' }}
      >
        {phrases.map((phrase, idx) => (
          <React.Fragment key={idx}>
            <span className="mx-4 text-lg font-semibold">{phrase}</span>
            {idx < phrases.length - 1 && (
            //   <TbSquareRoundedChevronRight size={30} className="mx-4 text-xl" />
            // <TbSquareRoundedChevronRight />
            <b>·</b>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default PhraseCarousel;
